<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs>
        <!-- 域策略 -->
        <el-tab-pane label="">
          <span slot="label">{{ $t("logs.ldap1") }}</span>
          <div class="main">
            <p>
              <!-- 输入查询域名 -->

              <span class="main_text"> {{ $t("logs.ldap7") }}:</span>

              <el-input
                v-model="domain"
                placeholder=""
                class="main_input"
                clearable
              ></el-input>
              <el-button
                @click="search_policy"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.ldap8") }}</el-button
              >
              <el-alert
                :title="this.show_hind1"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>

          <div class="switch1">
            <div class="table table1">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <el-table-column
                  prop="DOMAIN"
                  :label="$t('logs.base4')"
                  width="160"
                >
                </el-table-column>
                <el-table-column prop="SHOW_HINT" :label="$t('logs.ldap9')">
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.ldap9')"
                  width="160"
                >
                  <template scope="scope">
                    <el-select
                      size="small"
                      v-model="scope.row.ACTION"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in q_action_type_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <!--保存-->

                    <el-button
                      @click="save_policy(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.save") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
         
          </div>
        </el-tab-pane>
        <!-- 域默认动作 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.ldap2") }}</span>
          <div class="main">
            <p>
              <!-- 输入查询域名 -->

              <span class="main_text"> {{ $t("logs.ldap7") }}:</span>

              <el-input
                v-model="domain"
                placeholder=""
                class="main_input"
                clearable
              ></el-input>
              <el-button
                @click="search_action"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.ldap8") }}</el-button
              >
              <el-alert
                :title="this.show_hind2"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table table1">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="DOMAIN"
                  :label="$t('logs.base4')"
                  width="160"
                >
                </el-table-column>
                <el-table-column prop="SHOW_HINT" :label="$t('logs.ldap11')">
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.ldap12')"
                  width="160"
                >
                  <template scope="scope">
                    <el-select
                      size="small"
                      v-model="scope.row.TYPE"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in action_type_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->
                    <el-button
                      @click="save_action(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("tab.save") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu" v-drag>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    策略用户:
                  </div>
                  <div class="block block1">
                    <el-input v-model="input" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend()">保存</el-button>
                <el-button type="primary" @click="tanOff()">取消</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- 收件人列表及设置 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.ldap3") }}</span>
          <div class="main">
            <p>
              <span class="main_text"> {{ $t("logs.ldap13") }}:</span>

              <el-input
                v-model="username"
                placeholder=""
                class="main_input"
                clearable
              ></el-input>
              <el-button
                @click="search_set()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.ldap8") }}</el-button
              >

              <el-button
                @click="tan_username()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.ldap14") }}</el-button
              >
              <!-- 导入用户 -->

              <el-button
                @click="daoru()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.ldap16") }}</el-button
              >
            </p>
          </div>
          <div class="main main1">
            <el-alert
              :title="this.show_hind6"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table2">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList3"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  type="selection"
                  width="40"
                  v-model="multipleSelection"
                ></el-table-column>
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="60"
                >
                </el-table-column>
                <el-table-column prop="USERNAME" :label="$t('logs.autu5_a2')">
                </el-table-column>
                <el-table-column prop="SHOW_HINT" :label="$t('logs.ldap11')">
                </el-table-column>
                <el-table-column
                  prop="TYPE"
                  :label="$t('logs.ldap12')"
                  width="160"
                >
                  <template scope="scope">
                    <el-select
                      size="small"
                      v-model="scope.row.TYPE"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in user_type_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <!-- 保存 -->
                    <el-button
                      @click="save_set(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("tab.save") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!--  分页 -->
            <div class="fenye">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums"
              ></el-pagination>

              <el-button @click="bulkpass" class="el-icon-download1">{{
                $t("table.download")
              }}</el-button>
            </div>
            <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_tls_address' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_tls_address"><span class="span_pad"></span> {{$t('logs.ldap14')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.autu5_a2") }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 3, maxRows: 4 }"
                      :placeholder="this.show_hind3"
                      v-model="users"
                      style="margin:10px 0"
                    >
                    </el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.ldap12") }} :
                  </div>
                  <div class="block block1">
                    <el-select v-model="chktype" placeholder="请选择">
                      <el-option
                        v-for="item in user_type_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_username()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="off_username()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
            <div class="pop-up" v-show="tanchu_add" v-drag>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px"></div>
                  <div class="block block1">
                    <input
                      type="file"
                      @change="inputFileChange"
                      id="iupfile"
                      ref="clearFile"
                      accept=".txt"
                    />
                  </div>
                </div>
              </div>
              <el-row>
                <el-button type="primary" size="mini" @click="save022">{{
                  $t("tan.up")
                }}</el-button>
                <el-button type="danger" @click="save23()">{{
                  $t("tan.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_add"></div>
          </div>
        </el-tab-pane>
        <!-- LDAP收件人检查 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.ldap17") }}</span>
          <div class="main">
            <p>
              <span class="main_text"> {{ $t("logs.ldap17") }}:</span>
              <el-select v-model="ldap_check_user" placeholder="请选择">
                <el-option
                  v-for="item in ldap_check_user_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-button
                @click="save_ldap_check()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.save_a") }}</el-button
              >
              <el-button
                @click="tan_ldap_check()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.ldap18") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table_check">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList4"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="80"
                >
                </el-table-column>
                <el-table-column prop="HOST" :label="$t('logs.ldap19')">
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="160"
                >
                  <template scope="scope">
                    <!-- 删除 -->
                    <el-button
                      @click="del_ldap_list(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                    <!-- 编辑 -->
                    <el-button
                      @click="edit_ldap_list(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                    <!-- 验证-->
                    <el-button
                      @click="verify_ldap_list(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.verify") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_cert_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_cert_domain"><span class="span_pad"></span> {{$t('logs.ldap18')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    <!-- LDAP服务器: -->

                    {{ $t("logs.autu4_a2") }} :
                  </div>
                  <div class="block block1" style="display:flex">
                    <el-input v-model="ldap_host" placeholder=""></el-input>
                    <el-input
                      v-model="ldap_port"
                      placeholder=""
                      style="width:30%;margin-left:10px"
                    ></el-input>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Search Base:
                  </div>
                  <div class="block block1">
                    <el-input v-model="ldap_base" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Bind DN:
                  </div>
                  <div class="block block1">
                    <el-input v-model="bind_dn" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Password:
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="ldap_pass"
                      placeholder=""
                      show-password
                    ></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Query filter:
                  </div>
                  <div class="block block1">
                    <el-input v-model="filter" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div
                    style="padding:6px 12px;font-size:12px;color: #0E2C5E;line-height:16px"
                  >
                    查询参数设置，如需修改，mail为查找属性值，%s为查找对应邮箱地址，%u为查找邮箱地址@前的部分，如果要查找多个参数，在最后的添加即可，每个参数需要用括号括起来
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_ldap_list()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanOff()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
            <div class="pop-up" v-show="tanchu_ldap" v-drag="{ handle: '.pop_up_text_relay_domain_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_relay_domain_edit"><span class="span_pad"></span> {{$t('logs.ldap18_edit')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    <!-- LDAP服务器: -->

                    {{ $t("logs.autu4_a2") }} :
                  </div>
                  <div class="block block1" style="display:flex">
                    <el-input v-model="ldap_host" placeholder=""></el-input>
                    <el-input
                      v-model="ldap_port"
                      placeholder=""
                      style="width:30%;margin-left:10px"
                    ></el-input>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Search Base:
                  </div>
                  <div class="block block1">
                    <el-input v-model="ldap_base" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Bind DN:
                  </div>
                  <div class="block block1">
                    <el-input v-model="bind_dn" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Password:
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="ldap_pass"
                      placeholder=""
                      show-password
                    ></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Query filter:
                  </div>
                  <div class="block block1">
                    <el-input v-model="filter" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div
                    style="padding:6px 12px;font-size:12px;color: #0E2C5E;line-height:16px"
                  >
                    {{ this.hint_filt }}
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_edit_ldap_list()">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanOff_ldap()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_ldap"></div>
            <div class="pop-up" v-show="tanchu_verify" v-drag="{ handle: '.pop_up_text_url_b' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_url_b"><span class="span_pad"></span> {{$t('logs.ldap20')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Email:
                  </div>
                  <div class="block block1">
                    <el-input v-model="email" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_edit_verify_list()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.ldap20")
                }}</el-button>
                <el-button type="danger" @click="tanOff_verify()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_verify"></div>
          </div>
        </el-tab-pane>
        <!-- LDAP用户同步 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.ldap33") }}</span>
          <div class="main">
            <p>
              <!-- <span class="main_text"> {{ $t("logs.ldap34") }}:</span>
              <el-select v-model="ldap_check_user_sync" placeholder="请选择" style="width:140px">
                <el-option
                  v-for="item in ldap_check_user_sync_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> 
              <el-button
                @click="save_ldap_check_sync()"
                :disabled="$root.jurisdiction.only_query == 0"
               
                >{{ $t("logs.save_a") }}</el-button
              >-->
              <!-- 添加配置 -->
              <el-button
                @click="sync_add()"
                v-if="this.user_sync_button == 0"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.ldap38") }}</el-button
              >
              <!-- 手动同步 -->
              <el-button
                @click="manual_sync()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.ldap35") }}</el-button
              >
              <!-- 设置定时同步 -->
              <el-button
                @click="show_sync_time()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.ldap36") }}</el-button
              >
            </p>
          </div>
          <div
            class="pop-up pop-up1"
            v-show="tanchu_sync"
            v-drag="{ handle: '.pop_up_text_add' }"
          >
            <div class="pop_up_text pop_up_text_add">
              <span style="padding:0 14px"></span>{{ $t("logs.ldap36") }}
            </div>
            <p></p>
            <div class="find">
              <div class="find1">
                <div class="find-text" style="padding-right:12px">
                  {{ $t("logs.ldap37") }}:
                </div>
                <div class="block block1" style="display:flex;">
                  <el-input
                    v-model="set_time"
                    oninput="value=value.replace(/[^\d]|^0/g,'')"
                  ></el-input>
                </div>
              </div>
            </div>

            <el-row>
              <el-button type="primary" @click="save_time_out()">{{
                $t("tab.save")
              }}</el-button>
              <el-button type="danger" @click="tanOff_sync()">{{
                $t("tab.cancel")
              }}</el-button>
            </el-row>
          </div>
          <div class="gray" v-show="tanchu_sync"></div>
          <div class="switch1">
            <div class="table table_check">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_sync"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="80"
                >
                </el-table-column>
                <el-table-column prop="USER" :label="this.user_sync">
                </el-table-column>
              </el-table>
            </div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_sync_add' }"
            >
              <!--  路由设置-->
              <div class="pop_up_text pop_up_text_sync_add">
                <span style="padding:0 14px"></span>{{ $t("logs.ldap38") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    <!-- LDAP服务器: -->

                    {{ $t("logs.autu4_a2") }} :
                  </div>
                  <div class="block block1" style="display:flex">
                    <el-input v-model="ldap_host" placeholder=""></el-input>
                    <el-input
                      v-model="ldap_port"
                      placeholder=""
                      style="width:30%;margin-left:10px"
                    ></el-input>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Search Base:
                  </div>
                  <div class="block block1">
                    <el-input v-model="ldap_base" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Bind DN:
                  </div>
                  <div class="block block1">
                    <el-input v-model="bind_dn" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Password:
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="ldap_pass"
                      placeholder=""
                      show-password
                    ></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Query filter:
                  </div>
                  <div class="block block1">
                    <el-input v-model="filter" placeholder=""></el-input>
                  </div>
                </div>
                <!-- <div class="find1">
                  <div
                    style="padding:6px 12px;font-size:12px;color: #0E2C5E;line-height:16px"
                  >
                    查询参数设置，如需修改，mail为查找属性值，%s为查找对应邮箱地址，%u为查找邮箱地址@前的部分，如果要查找多个参数，在最后的添加即可，每个参数需要用括号括起来
                  </div>
                </div> -->
              </div>

              <el-row>
                <el-button type="primary" @click="save_ldap_list_sync()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanOff()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
            <div class="pop-up" v-show="tanchu_ldap" v-drag>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    <!-- LDAP服务器: -->

                    {{ $t("logs.autu4_a2") }} :
                  </div>
                  <div class="block block1" style="display:flex">
                    <el-input v-model="ldap_host" placeholder=""></el-input>
                    <el-input
                      v-model="ldap_port"
                      placeholder=""
                      style="width:30%;margin-left:10px"
                    ></el-input>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Search Base:
                  </div>
                  <div class="block block1">
                    <el-input v-model="ldap_base" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Bind DN:
                  </div>
                  <div class="block block1">
                    <el-input v-model="bind_dn" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Password:
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="ldap_pass"
                      placeholder=""
                      show-password
                    ></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Query filter:
                  </div>
                  <div class="block block1">
                    <el-input v-model="filter" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div
                    style="padding:6px 12px;font-size:12px;color: #0E2C5E;line-height:16px"
                  >
                    {{ this.hint_filt }}
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_edit_ldap_list()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanOff_ldap()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_ldap"></div>
            <div class="pop-up" v-show="tanchu_verify"  v-drag="{ handle: '.pop_up_text_url_w' }"
            >
              <!--  路由设置-->
              <div class="pop_up_text pop_up_text_url_w">
                <span style="padding:0 14px"></span>{{ $t("logs.ldap38") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    Email:
                  </div>
                  <div class="block block1">
                    <el-input v-model="email" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_edit_verify_list()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.ldap20")
                }}</el-button>
                <el-button type="danger" @click="tanOff_verify()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_verify"></div>
          </div>
        </el-tab-pane>
        <!-- LDAP域名配置 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.ldap5") }}</span>
          <div class="main main1">
            <p>
              <!-- 添加域名 -->

              <el-button
                @click="tan_domain()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.ldap22") }}</el-button
              >
              <el-alert
                :title="this.show_hind5"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList5"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="80"
                >
                </el-table-column>
                <el-table-column prop="DOMAIN" :label="$t('logs.base10_a4')">
                </el-table-column>
                <el-table-column prop="ACTION" :label="$t('logs.manage4')">
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="80"
                >
                  <template scope="scope">
                    <!-- 删除 -->
                    <el-button
                      @click="del_domain(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_addb' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_addb"><span class="span_pad"></span> {{$t('logs.ldap22')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base10_a4") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="domain_config" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.manage4") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="action" placeholder="请选择">
                      <el-option
                        v-for="item in action_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_domain()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="off_domain()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>

        <!-- 字典攻击配置 -->
        <el-tab-pane>
          <span slot="label"> {{ $t("logs.ldap6") }}</span>
          <div class="lie">
            <table>
              <tbody class="attack">
                 <!-- 字典攻击开关 -->
                <tr>
                  <td>{{ $t("logs.ldap24") }}:</td>
                  <td style="display:flex;flex-direction:row">
                    <el-checkbox-group v-model="enable_dictionary_attack">
                      <el-checkbox label=""></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('logs.ldap25')"
                      type="warning"
                      show-icon
                      :closable="false"
                    >
                    </el-alert>
                  </td>
                </tr>
              
                <!-- 最大错误收件人数 -->
                <tr>
                  <td>{{ $t("logs.ldap26") }}:</td>

                  <td style="display:flex;flex-direction:row">
                    <el-input v-model="max_badrcpts" placeholder=""></el-input>
                    <el-alert
                      :title="$t('logs.ldap27')"
                      type="warning"
                      show-icon
                      :closable="false"
                    >
                    </el-alert>
                  </td>
                </tr>
                <!-- 错误收件人延迟响应时间 -->
                <tr>
                  <td>{{ $t("logs.ldap28") }}:</td>

                  <td style="display:flex;flex-direction:row">
                    <el-input
                      v-model="max_delay_seconds"
                      placeholder=""
                      oninput="value=value.replace(/[^0-3]/g,'')"
                      maxlength="1"
                    ></el-input>
                    <el-alert
                      :title="$t('logs.ldap29')"
                      type="warning"
                      show-icon
                      :closable="false"
                    >
                    </el-alert>
                  </td>
                </tr>
                    <!-- 单个会话最大错误收件人数 -->
                <tr>
                  <td>{{ $t("logs.ldap39") }}:</td>
                  <td style="display:flex;flex-direction:row">
                   
                     <el-input
                      v-model="max_error_rcpt_one_session"
                      placeholder=""
                     oninput="value=value.replace(/[^\d]/g,'')"
                      maxlength="1"
                    
                    ></el-input>
                    <el-alert
                      :title="$t('logs.ldap40')"
                      type="warning"
                      show-icon
                      :closable="false"
                    >
                    </el-alert>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <el-row>
                      <el-button
                        type="primary"
                        @click="save_attack()"
                        :disabled="$root.jurisdiction.only_query == 0"
                        >{{ $t("logs.save_a") }}</el-button
                      >
                    </el-row>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {
      set_time: "",
      tanchu_sync: false,
      max_delay_seconds: "0",
      loading: false,
      max_badrcpts: "",
      max_error_rcpt_one_session:'',
      enable_dictionary_attack: false,
      domain_config: "",
      action: "OK",
      action_arr: [],
      hint_filt: "",
      email: "",
      domain: "",
      textarea: "",
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",

      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],
      tanchu: false,
      options: [
        {
          value: "选项1",
          label: "不使用TLS",
        },
        {
          value: "选项2",
          label: "增加信头标记",
        },
        {
          value: "选项3",
          label: "强制TLS",
        },
      ],
      checked: "",
      fileList: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList_sync: [],
      fileList5: [],
      fileList6: [],
      radio: [],
      q_action_type: 1,
      q_action_type_arr: [],
      show_hind1: "",
      show_hind2: "",
      show_hind3: "",
      show_hind4: "",
      show_hind5: "",
      show_hind6: "",
      username: "",
      multipleSelection: [],
      // 总数
      totalnums: 0,
      size: 0,
      // 每页条数
      pagesize: "",
      //   默认前往第几页
      page: 0,
      chktype: 1,
      user_type_arr: [],
      users: "",
      action_type_arr: [],
      tanchu_add: false,
      files: "",

      ldap_check_user_sync: "是",
      ldap_check_user_sync_arr:[],
      ldap_check_user: "",
      ldap_check_user_arr: [],
      filter: "",
      ldap_pass: "",
      bind_dn: "",
      ldap_base: "",
      ldap_host: "",
      ldap_port: "",
      file_ldap: "",
      tanchu_ldap: false,
      tanchu_verify: false,
      data_loadok: "",
      user_sync:'',
      user_sync_button:'',
      file_ldap_file:"",
    };
  },
  mounted() {
    this.getFileList();
    this.getFileList_action();
    this.getFileList_set();
    this.getFileList_check();
    this.getFileList_config();
    this.getFileList_attack();
    this.getFileList_sync();
  },
  methods: {

       // ladap检查是否启用
    save_ldap_check_sync() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "save_ldap_rsyn_type",
            sid: sid,
            rsyn_type: this.ldap_check_user_sync,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.getFileList_sync();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    //   同步保存
        save_ldap_list_sync() {
          this.$save_hint_test();
          this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "save_rsyn_ldap_cfg",
        sid: sid,
        filter: this.filter,
        ldap_pass: this.ldap_pass,
        bind_dn: this.bind_dn,
        ldap_base: this.ldap_base,
        ldap_host: this.ldap_host,
        ldap_port: this.ldap_port,
        file: "ldap_user3.cf",
      });
      this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
        // console.log(res)
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "2") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.getFileList_sync();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    //   ladp 用户同步添加
      sync_add(){

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "load_rsyn_ldap_cfg",
            sid: sid,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
                this.ldap_host = res.data.ret.result.LDAP_HOST;
            this.ldap_base = res.data.ret.result.LDAP_BASE;
            this.bind_dn = res.data.ret.result.BIND_DN;
            this.ldap_pass = res.data.ret.result.LDAP_PASS;
            this.filter = res.data.ret.result.QUERY_FILTER;
            this.ldap_port = res.data.ret.result.LDAP_PORT;
            // this.hint_filt = res.data.ret.LOAD_HINT;
            this.tanchu=true



          }
        });
      },
    // 加载
    getFileList_sync() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "load_ldap_rsyn_cfg",
            sid: sid,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList_sync = res.data.ret.datalist;
                this.user_sync=res.data.ret.user;
                this.ldap_check_user_sync=res.data.ret.rsyn_type
                this.ldap_check_user_sync_arr=res.data.ret.q_type
                if(this.ldap_check_user_sync==1){
              this.user_sync_button=1
               }else{
                this.user_sync_button=0

               }
            // this.show_hind4 = res.data.ret.LOAD_HINT;

            // 总条数

            this.loading = false;
          }
        });
    },
    save_time_out() {
       let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "save_ldap_rsyn_time",
        sid: sid,
        rsync_time: this.set_time,
       
      });
      this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
        // console.log(res)
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "2") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
              this.tanchu_sync = false;

          this.getFileList_check();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      })
    
   
    },
    tanOff_sync() {
      this.tanchu_sync = false;
    },
    // 手动同步
    manual_sync() {
        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "manual_rsyn_ldap_user",
        sid: sid,
       
       
      });
      this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
        // console.log(res)
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "2") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
              // this.tanchu_sync = false;

          this.getFileList_check();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      })
    },
    show_sync_time() {
        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "load_ldap_rsyn_time",
        sid: sid,
       
       
      });
      this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
        // console.log(res)
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "2") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
             this.tanchu_sync = true;
            this.set_time=res.data.ret.result.RSYNC_TIME
         
        }
      })
      
    },
    save_attack() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "save_dictionary_attack",
        sid: sid,
        max_error_rcpt_one_session:this.max_error_rcpt_one_session,
        enable_dictionary_attack: this.enable_dictionary_attack == true ? 1 : 0,
        max_badrcpts: this.max_badrcpts,
        max_delay_seconds: this.max_delay_seconds,
        data_loadok: this.data_loadok,
      });

      this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
        // console.log(res)
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "2") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.getFileList_attack();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // ladap收件人删除
    del_domain(index, row) {
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_ldap_dn_act",
                sid: sid,
                domain: row.DOMAIN,

                // screen: "real_filterlog.html",
              },
            })
            .then((res) => {
              // console.log(res)
              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                this.$message({
                  type: "error",
                  message: `${res.data.fmstatus.errmsg}`,
                });
              } else if (res.data.fmstatus.code == "2") {
                this.$message({
                  type: "error",
                  message: `${res.data.fmstatus.errmsg}`,
                });
              } else if (res.data.fmstatus.code == "3") {
                // alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.getFileList_config();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    save_domain() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "save_ldap_dn_act",
        sid: sid,
        domain: this.domain_config,
        action: this.action,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res)
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "2") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.getFileList_config();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    off_domain() {
      this.tanchu = false;
    },
    tan_domain() {
      this.domain_config=''
      this.tanchu = true;
    },
    save_edit_verify_list() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "verify_ldap_cfg",
        sid: sid,
        email: this.email,
        file: this.file_ldap,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res)
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "2") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.getFileList_check();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // ladap收件人删除
    del_ldap_list(index, row) {
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_ldap_cfg",
                sid: sid,
                file: row.FILE,

                // screen: "real_filterlog.html",
              },
            })
            .then((res) => {
              // console.log(res)
              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                this.$message({
                  type: "error",
                  message: `${res.data.fmstatus.errmsg}`,
                });
              } else if (res.data.fmstatus.code == "2") {
                this.$message({
                  type: "error",
                  message: `${res.data.fmstatus.errmsg}`,
                });
              } else if (res.data.fmstatus.code == "3") {
                // alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.getFileList_check();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    save_edit_ldap_list() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "save_ldap_cfg",
        sid: sid,
        filter: this.filter,
        ldap_pass: this.ldap_pass,
        bind_dn: this.bind_dn,
        ldap_base: this.ldap_base,
        ldap_host: this.ldap_host,
        ldap_port: this.ldap_port,
        file: this.file_ldap,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res)
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "2") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu_ldap = false;
          this.getFileList_check();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    tanOff_ldap() {
      this.tanchu_ldap = false;
    },
    edit_ldap_list(index, row) {
      this.file_ldap = row.FILE;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "add_ldap_cfg",
            sid: sid,
            file: this.file_ldap,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
          } else if (res.data.fmstatus.code == "2") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu_ldap = true;

            // this.ldap_host = res.data.ret.LDAP_HOST
            this.ldap_host = res.data.ret.LDAP_HOST;
            this.ldap_base = res.data.ret.LDAP_BASE;
            this.bind_dn = res.data.ret.BIND_DN;
            this.ldap_pass = res.data.ret.LDAP_PASS;
            this.filter = res.data.ret.QUERY_FILTER;
            this.ldap_port = res.data.ret.LDAP_PORT;
            this.hint_filt = res.data.ret.LOAD_HINT;
          }
        });
    },
    tanOff_verify() {
      this.tanchu_verify = false;
    },
    verify_ldap_list(index, row) {
      this.file_ldap = row.FILE;
      this.tanchu_verify = true;
      this.email = "";
    },
  tan_ldap_check() {
      // this.file_ldap = row.FILE;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "add_ldap_cfg",
            sid: sid,
            

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
          } else if (res.data.fmstatus.code == "2") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = true;

          
            this.file_ldap_file = res.data.ret.FILE;
            
          }
        });
    },
    save_ldap_list() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "save_ldap_cfg",
        sid: sid,
        filter: this.filter,
        ldap_pass: this.ldap_pass,
        bind_dn: this.bind_dn,
        ldap_base: this.ldap_base,
        ldap_host: this.ldap_host,
        ldap_port: this.ldap_port,
        file: this.file_ldap_file,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res)
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "2") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.getFileList_check();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // ladap检查是否启用
    save_ldap_check() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "save_ldap_dft_chk",
            sid: sid,
            ldap_check_user: this.ldap_check_user,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.getFileList_check();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    // 加载
    getFileList_attack() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "load_dictionary_attack",
            sid: sid,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
             this.max_error_rcpt_one_session = res.data.ret.result.max_error_rcpt_one_session;
            this.enable_dictionary_attack =
              res.data.ret.result.dictionary_attack_check == 1 ? true : false;
            this.max_badrcpts = res.data.ret.result.max_badrcpts;
            this.max_delay_seconds = res.data.ret.result.max_delay_seconds;
            this.data_loadok = res.data.ret.ok;

            // 总条数

            this.loading = false;
          }
        });
    },
    // 加载
    getFileList_config() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_ldap_dn_act",
            sid: sid,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList5 = res.data.ret.datalist;
            this.action_arr = res.data.ret.q_type;

            this.show_hind5 = res.data.ret.LOAD_HINT;

            // 总条数

            this.loading = false;
          }
        });
    },
    // 加载
    getFileList_check() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_ldap_cfg",
            sid: sid,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList4 = res.data.ret.datalist;
            this.ldap_check_user_arr = res.data.ret.q_type;
            this.ldap_check_user = res.data.ret.ldap_check_user;
            this.show_hind4 = res.data.ret.LOAD_HINT;

            // 总条数

            this.loading = false;
          }
        });
    },
    inputFileChange(e) {
      this.files = e.target.files[0];
      // console.log(this.files);
    },
    save23() {
      this.tanchu_add = false;
    },
    // 白名单增加
    save022() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      let iupfile = this.files;
      // console.log(iupfile);
      // 判断是否有文件
      if (0 == this.files.length) {
        this.$message({
          type: "info",
          message: "请选择要上传的文件",
        });
        return;
      } else {
        this.tanchu = false;
        let fd = new FormData();
        fd.append("iupfile", iupfile);
        // for (var i = 0; i < this.files.length; i++) {
        //     fd.append('fileUpload', this.files[i]);
        // }
        fd.append("__mode", "upload_user_chk");
        fd.append("sid", sid);
        // console.log(fd);
        this.$axios({
          method: "post",
          url: "/api/adm/cgi/newspam.cgi",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: fd,
        }).then((res) => {
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "2") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.$refs.clearFile.value = ""; // 清空file文件

            // this.getFileList2();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;

            this.getFileList_set();
            this.$refs.clearFile.value = ""; // 清空file文件
            this.files = "";
            console.log(this.files);
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.del3")}`,
            });
          }
          // this.getFileList2();
        });
      }
    },
    daoru() {
      this.tanchu_add = true;
    },
    search_set() {
      this.getFileList_set();
    },
    // 加载
    getFileList_set() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_user_chk_type",
            sid: sid,
            username: this.username,
            page: this.page,
            pagesize: this.size,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList3 = res.data.ret.datalist;
            this.user_type_arr = res.data.ret.q_type;
            this.show_hind3 = res.data.ret.LOAD_HINT1;
            this.show_hind6 = res.data.ret.LOAD_HINT2;
            this.totalnums = res.data.ret.TOTALNUMS;
            this.page = res.data.ret.PAGE;
            this.size = res.data.ret.PAGESIZE;
            // 总条数
            // console.log(this.pagesize)
            this.loading = false;
          }
        });
    },

    save_username() {
     this.$save_hint_test();
     this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "save_user_chk_type",
        sid: sid,
        users: this.users,
        chktype: this.chktype,
        bulkadd: 1,
      });

      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res)
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
          this.loading = false;
        } else if (res.data.fmstatus.code == "2") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
          this.loading = false;
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          // this.loading = false;
          this.getFileList_set();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // 域动作保存
    save_set(index, row) {
      // this.loading = true;
      // console.log(index, row)
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "save_user_chk_type",
        sid: sid,
        username: row.USERNAME,
        chktype: row.TYPE,
      });

      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res)
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
          this.loading = false;
        } else if (res.data.fmstatus.code == "2") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
          this.loading = false;
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          // this.loading = false;
          this.getFileList_set();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    search_action() {
      this.getFileList_action();
    },
    // 加载
    getFileList_action() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_dn_chk_type",
            sid: sid,
            domain: this.domain,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList2 = res.data.ret.datalist;
            this.action_type_arr = res.data.ret.q_type;
            this.show_hind2 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },
    // 域动作保存
    save_action(index, row) {
      // this.loading = true;
      // console.log(index, row)
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "save_dn_chk_type",
        sid: sid,
        domain: row.DOMAIN,
        chktype: row.TYPE,
      });

      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res)
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
          this.loading = false;
        } else if (res.data.fmstatus.code == "2") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
          // alert(res.data.fmstatus.errmsg);
          this.loading = false;
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          // this.loading = false;
          this.getFileList_action();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    search_policy() {
      this.getFileList();
    },
    // 加载
    getFileList() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_dn_chk_act",
            sid: sid,
            domain: this.domain,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList = res.data.ret.datalist;
            this.q_action_type_arr = res.data.ret.q_type;
            this.show_hind1 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },
    // 域策略保存
    save_policy(index, row) {
      // this.loading = true;
      // console.log(index, row)
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "save_dn_chk_act",
        sid: sid,
        domain: row.DOMAIN,
        chkaction: row.ACTION,
      });

      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
          this.loading = false;
        } else if (res.data.fmstatus.code == "2") {
          this.$message({
            type: "error",
            message: `${res.data.fmstatus.errmsg}`,
          });
          this.loading = false;
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          // this.loading = false;
          this.getFileList();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // 显示
    tan: function() {
      this.tanchu = true;
      (this.ldap_host = ""),
        (this.ldap_port = ""),
        (this.ldap_base = ""),
        (this.bind_dn = ""),
        (this.ldap_pass = ""),
        (this.filter = "");
    },
    tan_username: function() {
      this.tanchu = true;
      this.users = "";
      this.chktype = 1;
    },
    off_username: function() {
      this.tanchu = false;
    },
    // 打开关闭
    tanSend: function() {
      this.tanchu = false;
    },
    tanOff: function() {
      this.tanchu = false;
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
    // 每页显示多少条 -- 切换
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.size = val;
      //  this.tanSend()

      // this.tanSend(this.search,this.pagesize)
      this.getFileList_set();
    },
    // 当前第几页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      //  this.tanSend(this.search,this.pagesize)
      // console.log(this.page, '1111', val);
      this.getFileList_set();
    },
    // 批量放行

    bulkpass() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: "请至少勾选一项，再进行操作",
          type: "warning",
        });
        return;
      } else {
        this.loading = true;

        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
        console.log(sid);
        // console.log(this)
        // 获取表单数据,搜索条件
        let col = this.col;

        var arr = this.multipleSelection;
        // console.log(arr, "全选后，获取的数组");
        let multis = [];
        for (var i = 0; i < arr.length; i++) {
          multis.push(arr[i].SEL_ID);
        }
        console.log(multis, "选中后的批量放行id");
        let multis1 = JSON.stringify(multis);
        this.$axios
          .get("/api/adm/cgi/elkspam.cgi", {
            params: {
              __mode: " list_elk_rejectmail",
              sid: sid,
              col: col,

              bulkpassflag: 1,
              msg_json: multis1,
              // screen: "real_filterlog.html",
            },
          })
          .then((res) => {
            console.log(res);
            if (!res) {
              this.loading = false;
            } else if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "2") {
              this.$message({
                type: "error",
                message: `${res.data.fmstatus.errmsg}`,
              });
              this.loading = false;
            } else if (res.data.fmstatus.code == "3") {
              this.$message({
                type: "error",
                message: `${res.data.fmstatus.errmsg}`,
              });
              this.$router.push({
                name: "login",
              });
            } else {
              this.fileList = res.data.ret.datalist;

              this.totalnums = res.data.ret.col.totalnums;
              this.size = res.data.ret.col.pagesize;
              this.loading = false;
            }
          })
          .catch((err) => {
            console.log("接口错误");
            console.log(err);
            alert(err);
          });
      }
    },

    //
  },
};
</script>

<style lang="less" scoped>
.table_check {
  /deep/ .has-gutter th:nth-child(1) {
    text-align: center;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(1) {
    text-align: center;
  }
}

.table1 {
  /deep/ .has-gutter th:nth-child(4) {
    text-align: center;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(4) {
    text-align: center;
  }
}

.table2 {
  /deep/ .has-gutter th:nth-child(6) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(1) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(2) {
    text-align: center;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(6) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(1) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(2) {
    text-align: center;
  }
}

// 1
.main {
  display: flex;

  align-items: center;
  border: 2px solid #d2d7e6;
  // background: #f1f1f1;
  margin: 0px;

  text-align: left;
  //   margin-top: 20px;
}

.main p {
  height: 44px;
  width: 100%;
  display: flex;
  padding-left: 10px;
  font-size: 12px;

  align-items: center;
  // line-height: 28px;
}

.main_text {
  margin-right: 6px;
  color: #0e2c5e;
}

.main .main_input {
  margin-right: 6px;
  width: 20%;
}

.main .el-select {
  margin-right: 6px;
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

/deep/ .el-checkbox {
  margin-right: 8px;
}

.main .el-alert {
  height: 36px;
  line-height: 0;
  width: 65%;
}

.el-alert__title {
  font-size: 12px;
  line-height: 16px;
}

.fenye {
  margin-bottom: 14px !important;
  border-left: 2px solid #d2d7e6;
  border-right: 2px solid #d2d7e6;
  border-bottom: 1px solid #d2d7e6;
  // border-bottom: 1px solid #D2D7E6;
  box-shadow: 0px 1px 0px 0px #d2d7e6;
  // margin-bottom: 5px;
  // border: 1px solid #ddd;
  height: 44px;
  // line-height:48px;

  line-height: 44px;
  display: flex;
  border-top: 0;
  align-items: center;

  margin: 0 14px;
  font-size: 14px;

  // background: #eee;
  /deep/ .el-select {
    padding: 0px 0px;
  }

  padding-left: 10px;
}

.table2 {
  margin-bottom: 0;
}

// 分页字体
/deep/ .el-pagination span:not([class*="suffix"]) {
  font-size: 14px;

  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #818ea8;
  line-height: 32px;
  height: 32px;
}

.fenye /deep/.el-pagination .el-select .el-input {
  width: 96px;
}

.fenye /deep/.el-pagination .el-select .el-input .el-input__inner {
  border-radius: 6px;
  border-radius: 6px;
  // width: 88px;
  border: 1px solid #d9d9d9;
}

.fenye /deep/.el-pagination .el-select .el-input .el-input__inner {
  padding-right: 6px;
  padding-left: 0px;

  font-weight: 400;
  color: #0e2c5e;
  font-family: PingFangSC-Regular, PingFang SC;
}

/deep/ .el-select .el-input .el-select__caret {
  font-size: 16px;
  color: #333;
}

/deep/ .el-pager {
  // line-height: 44px;
  // height: 44px;
  display: flex;
  align-items: center;
}

/deep/ .el-pager li {
  min-width: 32px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  // width: 32px;
  height: 32px;
  font-family: HelveticaNeue;
  color: #0e2c5e;
  font-size: 14px;
  margin: 0px 4px;
  font-weight: 500;
}

/deep/ .el-pager li.active {
  background: #006be7;
  color: #ffffff;
}

/deep/ .el-pagination__sizes {
  margin-right: 8px;
}

/deep/ .el-pagination button {
  height: 46px;
  line-height: 46px;
  padding: 0;
}

/deep/ .el-pagination .btn-prev {
  padding-right: 0;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  width: 32px;
  height: 32px;
}

/deep/ .el-pagination .btn-next {
  padding-right: 0;
  margin-left: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  width: 32px;
  height: 32px;
}

/deep/.el-pagination .btn-prev .el-icon {
  font-size: 16px;
  font-weight: 600;
}

/deep/.el-pagination .btn-next .el-icon {
  font-size: 16px;
  font-weight: 600;
}

/deep/.el-pagination button:disabled {
  color: #333;
}

/deep/ .el-pagination__jump {
  color: #0e2c5e !important;
  border-radius: 6px;
  // border: 1px solid #D9D9D9;
  margin-left: 8px;
  height: 32px;

  .el-pagination__editor.el-input .el-input__inner {
    height: 32px;
  }

  .el-input__inner {
    padding-left: 0;
  }
}

.el-icon-download1 {
  color: #fff;
}

.main1 {
  border: 0;
  margin-left: 4px;

  .el-alert {
    width: auto;
  }
}

.attack {
  /deep/ .el-alert {
    width: 100% !important;
  }
}
.pop-up .pop_up_text_add,
.pop-up .pop_up_text_sync_add {
  width: 100%;
}
.pop_up_text_add,
.pop_up_text_sync_add {
  background: #eee;
}
</style>
